import apiClient from './api';

// Onboarding wizard (docs/design/contracts.md §7 Onboarding). Every call goes through the shared apiClient, so the
// signed-in user's bearer token is attached; the API takes the tenant from that token, never from the body.
export const onboardingAPI = {
  start: async (details) => (await apiClient.post('/onboarding/start', details)).data,
  getStatus: async (onboardingId) => (await apiClient.get(`/onboarding/${encodeURIComponent(onboardingId)}`)).data,
  getConsentUrl: async (onboardingId) => (await apiClient.get(`/onboarding/${encodeURIComponent(onboardingId)}/consent-url`)).data,
  configureGraph: async (onboardingId, credentials) =>
    (await apiClient.post(`/onboarding/${encodeURIComponent(onboardingId)}/configure-graph`, credentials)).data,
  validate: async (onboardingId) => (await apiClient.post(`/onboarding/${encodeURIComponent(onboardingId)}/validate`)).data,
  startImport: async (onboardingId, importFromDate) =>
    (await apiClient.post(`/onboarding/${encodeURIComponent(onboardingId)}/import`, { importFromDate })).data,
  getImportProgress: async (onboardingId) =>
    (await apiClient.get(`/onboarding/${encodeURIComponent(onboardingId)}/import/progress`)).data,
  complete: async (onboardingId) => (await apiClient.post(`/onboarding/${encodeURIComponent(onboardingId)}/complete`)).data,
  resumeImport: async (onboardingId) =>
    (await apiClient.post(`/onboarding/${encodeURIComponent(onboardingId)}/retry`, { step: 'DataImportStarted' })).data,
};

// Hierarchy and routing configuration used by the "Organize communities" step (contracts.md §7, A009). The first
// administrator is created when the connection checks pass, so these account_admin routes work from that step on.
export const onboardingConfigAPI = {
  getLevels: async () => (await apiClient.get('/config/hierarchy/levels')).data,
  saveLevels: async (levels) => (await apiClient.put('/config/hierarchy/levels', levels)).data,
  getNodes: async () => (await apiClient.get('/config/hierarchy/nodes')).data,
  getCommunities: async () => (await apiClient.get('/config/communities')).data,
  getMappings: async () => (await apiClient.get('/config/mappings')).data,
  getSuggestions: async () => (await apiClient.get('/config/mappings/suggestions')).data,
  updateMapping: async (mapping) => (await apiClient.put(`/config/mappings/${encodeURIComponent(mapping.id)}`, mapping)).data,
  importCommunities: async (csvText, dryRun) =>
    (await apiClient.post(`/config/communities/import?dryRun=${dryRun ? 'true' : 'false'}`, csvText, { headers: { 'Content-Type': 'text/csv' } })).data,
  createUser: async (user) => (await apiClient.post('/config/users', user)).data,
};
